import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { IssueStatus, Status, Type } from '@/entities/todo';
import { IssuePriority } from '@/entities/issue';
import { authorizedTo, group, id, meta, nullableUser, score, entityItem, users } from '@/services/api';

const issue = t.type({
  id,
  priority: t.union([
    t.literal(IssuePriority.Low),
    t.literal(IssuePriority.Normal),
    t.literal(IssuePriority.High),
  ]),
  updatedAt: DateFromUnixTime,
  status: t.union([
    t.literal(IssueStatus.Pending),
    t.literal(IssueStatus.InProgress),
    t.literal(IssueStatus.Done),
    t.literal(IssueStatus.CantDo),
  ]),
  assignedGroups: t.array(group),
});

const inspection = t.type({
  id,
  score,
  maxScore: score,
  conductedAt: t.union([DateFromUnixTime, t.null]),
  percentage: t.union([t.number, t.null]),
  assignedGroups: t.array(group),
});

export const data = t.type({
  title: t.string,
  status: t.union([
    t.literal(Status.Pending),
    t.literal(Status.InProgress),
    t.literal(Status.Done),
    t.literal(Status.CantDo),
    t.literal(Status.SystemRejected),
  ]),
  type: t.union([
    t.literal(Type.Issue),
    t.literal(Type.Inspection),
  ]),
  createdAt: DateFromUnixTime,
  dueAt: t.union([DateFromUnixTime, t.null]),
  doneAt: t.union([DateFromUnixTime, t.null]),
  createdBy: nullableUser,
  doneBy: nullableUser,
  assignees: users,
  entityItem: t.union([entityItem, t.null]),
  issue: t.union([issue, t.null]),
  inspection: t.union([inspection, t.null]),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  status: t.number,
  dueAt: t.union([DateFromUnixTime, t.null]),
  assignees: t.array(t.number),
  entityItem: t.union([t.number, t.null]),
});

export const paginationCountCodec = t.type({
  data: t.type({
    total: t.number,
  }),
});
